import { VideoOff } from 'lucide-react';

/**
 * Draft preview: the backend hands a CloudFront-signed URL to a plain MP4, so a native
 * <video> is enough (pattern: MediaViewerDialog's non-Mux fallback). Null -> placeholder.
 */
export function TfxPreviewVideo({ url }: { url?: string | null | undefined }) {
  if (!url) {
    return (
      <div className="flex aspect-video w-56 shrink-0 flex-col items-center justify-center gap-2 rounded-md border border-dashed bg-muted/40 text-muted-foreground">
        <VideoOff className="size-5" />
        <span className="text-xs">No preview yet</span>
      </div>
    );
  }
  return (
    <video
      src={url}
      controls
      playsInline
      preload="metadata"
      className="aspect-video w-56 shrink-0 rounded-md border bg-black object-contain"
    />
  );
}
